import React from 'react';
import { Link } from 'react-router-dom';

export const AdminMenu = () => (
  <>
    <li>
      <Link to="/admin">Admin</Link>
    </li>
    <li>
      <Link tag={Link} to="/components">Components</Link>
    </li>
  </>
);